export default "__VITE_ASSET__BI$wlu4N__"